export default {
	LOAD: 'LazySrcLoad',
	IMG_LOAD: 'LazySrcImgLoad',
	IMG_ERROR: 'LazySrcImgError',
};
